@if (loaderIcon | async) {
  <app-preloader></app-preloader>
}
<div class="modal-content">
  <div class="modal-header">
    <h5 class="modal-title">{{paymentModeText}}</h5>
    <button type="button" class="close" data-dismiss="modal" aria-label="Close" [disabled] = "isDisableSubmit" (click)="closeStripeForm()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body">
    <form id="payment-form">
      <div id="payment-element">
        <!--Stripe.js injects the Payment Element-->
      </div>
      <div id="address-element">
        <!--Stripe.js injects the Address Element-->
      </div>
      <button id="submit" style="display: none;">
        <div class="spinner hidden" id="spinner"></div>
        <span id="button-text">Pay</span>
      </button>
      <div id="payment-message" class="hidden"></div>
    </form>
  </div>

  @if (isStripeReady) {
    <div class="modal-footer">
      @if (!isAchOrEftPayment()) {
        <div>
          <label class="pure-material-checkbox float-left">
            <input type="checkbox" class="checkBoxClass"
              (change)="onClickAutoPopulateBillingInfo($event.target.checked)">
              <span class="charitypay_text mt-0">Auto Populate Customer Information</span>
            </label>
          </div>
        }
        <div class="pay_rgt_butt" >
          @if (!isEftPayment()) {
            <div>
              <button type="button" class="btn btn-outline-primary me-3" (click)="closeStripeForm()">Cancel</button>
              <button (click)="onStripePay()" class="btn btn-primary">{{submitButtonName}}</button>
            </div>
          }
        </div>
      </div>
    }
  </div>